export default "__VITE_ASSET__DSPIe5WA__"